import type { PropsWithChildren } from 'react';
import { Portal } from '@elfsight/widget-modal';
import { CustomCSS } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { EmbedContainer } from './components/embed-container';
import { useEmbedPosition } from './hooks/use-embed-position';

type EmbedProps = PropsWithChildren<{
  customCSSPrefixClassName: string;
}>;

export function Embed({ children, customCSSPrefixClassName }: EmbedProps) {
  const { customCSS, font, embedType, position } = useSettings();

  const { position: positionValue } = position;

  const { alignment, floatingMargin } = useEmbedPosition({
    embedType,
    position
  });

  if (embedType === 'floating') {
    return (
      <Portal>
        <CustomCSS
          customCSS={customCSS}
          prefixClassName={customCSSPrefixClassName}
        />

        <EmbedContainer
          embedType={embedType}
          alignment={alignment}
          position={positionValue}
          floatingMargin={floatingMargin}
        >
          {children}
        </EmbedContainer>
      </Portal>
    );
  }

  return (
    <>
      <CustomCSS
        customCSS={customCSS}
        prefixClassName={customCSSPrefixClassName}
      />

      <EmbedContainer
        customCSSClassName={customCSSPrefixClassName}
        font={font}
        embedType={embedType}
        alignment={alignment}
        position={positionValue}
        floatingMargin={floatingMargin}
      >
        {children}
      </EmbedContainer>
    </>
  );
}
